import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Select } from '@actual-app/components/select';
import { Text } from '@actual-app/components/text';
import { theme as themeStyle } from '@actual-app/components/theme';
import type { Theme } from '@actual-app/core/types/prefs';
import { css } from '@emotion/css';

import { getThemeOptions, useTheme } from '#style';

import { Column, Setting } from './UI';

// Rumbo: solo automático, claro y oscuro propios (sin temas descargados).
export function ThemeSettings() {
  const { t } = useTranslation();
  const [theme, switchTheme] = useTheme();

  return (
    <Setting
      primaryAction={
        <Column title={t('Theme')}>
          <Select<Theme>
            onChange={value => switchTheme(value)}
            value={theme}
            options={getThemeOptions(t)}
            className={css({
              '&[data-hovered]': {
                backgroundColor: themeStyle.buttonNormalBackgroundHover,
              },
              maxWidth: '100%',
            })}
          />
        </Column>
      }
    >
      <Text>
        <Trans>
          <strong>Themes</strong> change the user interface colors.
        </Trans>
      </Text>
    </Setting>
  );
}
